module.exports = __webpack_public_path__ + "img/secCtrlCenter_getInfo.64948258.png";